import { CreditCard, Building2, Wallet } from "lucide-react";
import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface PaymentMethodSelectorProps {
  value: string;
  onChange: (value: string) => void;
}

export const PaymentMethodSelector = ({ value, onChange }: PaymentMethodSelectorProps) => {
  const banks = [
    "ABN AMRO",
    "ING",
    "Rabobank",
    "SNS Bank",
    "ASN Bank",
    "RegioBank",
    "Triodos Bank",
  ];

  return (
    <div className="space-y-4">
      <RadioGroup value={value} onValueChange={onChange} className="space-y-3">
        {/* iDEAL */}
        <div className="flex items-center space-x-3 border-2 border-muted rounded-lg p-4 hover:border-gold transition-colors cursor-pointer">
          <RadioGroupItem value="ideal" id="ideal" />
          <Label htmlFor="ideal" className="flex items-center gap-3 cursor-pointer flex-1">
            <Building2 className="w-5 h-5 text-primary" />
            <div className="flex-1">
              <p className="font-semibold">iDEAL</p>
              <p className="text-xs text-muted-foreground">Betaal direct via je bank</p>
            </div>
          </Label>
        </div>

        {value === "ideal" && (
          <div className="ml-12 mb-4">
            <Label className="text-sm mb-2 block">Kies je bank</Label>
            <Select>
              <SelectTrigger className="w-full">
                <SelectValue placeholder="Selecteer bank" />
              </SelectTrigger>
              <SelectContent>
                {banks.map((bank) => (
                  <SelectItem key={bank} value={bank.toLowerCase()}>
                    {bank}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        )}

        {/* Credit Card */}
        <div className="flex items-center space-x-3 border-2 border-muted rounded-lg p-4 hover:border-gold transition-colors cursor-pointer">
          <RadioGroupItem value="creditcard" id="creditcard" />
          <Label htmlFor="creditcard" className="flex items-center gap-3 cursor-pointer flex-1">
            <CreditCard className="w-5 h-5 text-primary" />
            <div className="flex-1">
              <p className="font-semibold">Creditcard</p>
              <p className="text-xs text-muted-foreground">Visa, Mastercard, American Express</p>
            </div>
          </Label>
        </div>

        {/* PayPal */}
        <div className="flex items-center space-x-3 border-2 border-muted rounded-lg p-4 hover:border-gold transition-colors cursor-pointer">
          <RadioGroupItem value="paypal" id="paypal" />
          <Label htmlFor="paypal" className="flex items-center gap-3 cursor-pointer flex-1">
            <Wallet className="w-5 h-5 text-primary" />
            <div className="flex-1">
              <p className="font-semibold">PayPal</p>
              <p className="text-xs text-muted-foreground">Betaal met je PayPal account</p>
            </div>
          </Label>
        </div>

        {/* Klarna */}
        <div className="flex items-center space-x-3 border-2 border-muted rounded-lg p-4 hover:border-gold transition-colors cursor-pointer">
          <RadioGroupItem value="klarna" id="klarna" />
          <Label htmlFor="klarna" className="flex items-center gap-3 cursor-pointer flex-1">
            <CreditCard className="w-5 h-5 text-primary" />
            <div className="flex-1">
              <p className="font-semibold">Klarna</p>
              <p className="text-xs text-muted-foreground">Achteraf betalen in 30 dagen</p>
            </div>
          </Label>
        </div>
      </RadioGroup>
    </div>
  );
};
